// extracted by mini-css-extract-plugin
export default {"button":"CheckBox_button__VJszB","required":"CheckBox_required__GA8Dt"};